import { render } from "./CreateFluxo.vue?vue&type=template&id=7027d2ea"
import script from "./CreateFluxo.vue?vue&type=script&lang=js"
export * from "./CreateFluxo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__